import { Heading_default } from "./chunk-EXW7ZGG6.js";
import { Icon_default } from "./chunk-BTGG6N6L.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/Card/Card.tsx
import React, { forwardRef, useMemo, cloneElement } from "react";
import clsx from "clsx";
var DEFAULT_COMPONENT = "article";
var CARD_CLASSNAME_MAP = {
  variant: {
    vertical: "pd-card--vertical",
    horizontal: "pd-card--horizontal",
    square: "pd-card--vertical pd-card--sm"
  },
  size: {
    md: "",
    sm: "pd-card--sm"
  }
};
var Card = forwardRef((_a, ref) => {
  var _b = _a,
    {
      as,
      children,
      variant = "vertical",
      size = "md",
      link,
      title: titleProp,
      image,
      badge,
      className
    } = _b,
    rest = __objRest(_b, ["as", "children", "variant", "size", "link", "title", "image", "badge", "className"]);
  const Component = as || DEFAULT_COMPONENT;
  const title = useMemo(() => {
    var _a2;
    return cloneElement(link, {
      children: titleProp,
      className: clsx("pd-card__action", (_a2 = link.props) == null ? void 0 : _a2.className)
    });
  }, [link, titleProp]);
  const headingSize = useMemo(() => {
    if (variant === "vertical" && size === "sm") {
      return "4";
    }
    return "3";
  }, [variant, size]);
  return /* @__PURE__ */React.createElement(Component, __spreadValues({
    ref,
    className: clsx("pd-nested-actions", "pd-card", CARD_CLASSNAME_MAP.variant[variant], CARD_CLASSNAME_MAP.size[size], className)
  }, rest), image && /* @__PURE__ */React.createElement("figure", {
    className: "pd-card__img"
  }, image, variant !== "horizontal" && badge && /* @__PURE__ */React.createElement("div", {
    className: "pd-card__badge"
  }, badge)), /* @__PURE__ */React.createElement("div", {
    className: "pd-card__content"
  }, /* @__PURE__ */React.createElement(Heading_default, {
    as: "div",
    size: headingSize,
    variant: "display",
    className: "pd-card__heading"
  }, title), (variant === "horizontal" || variant === "vertical" && size === "md") && children && /* @__PURE__ */React.createElement("div", {
    className: "pd-card__description"
  }, children), variant === "horizontal" && badge && /* @__PURE__ */React.createElement("div", {
    className: "pd-card__badge"
  }, badge)), variant === "horizontal" && /* @__PURE__ */React.createElement(Icon_default, {
    icon: "chevron-right",
    className: "pd-card__chevron"
  }));
});
var StoryCard = args => /* @__PURE__ */React.createElement(Card, __spreadValues({}, args));
var Card_default = Card;
export { CARD_CLASSNAME_MAP, StoryCard, Card_default };